module.exports = __webpack_public_path__ + "img/title-4.cf6cd3c1.png";